var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container"},[_c('NcCheckboxRadioSwitch',{attrs:{"type":"switch","checked":_vm.isProfileEnabled,"loading":_vm.loading},on:{"update:checked":[function($event){_vm.isProfileEnabled=$event},_vm.saveEnableProfile]}},[_vm._v("\n\t\t"+_vm._s(_vm.t('settings', 'Enable Profile'))+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }